module.exports = __webpack_public_path__ + "img/contact.a3b16a66.svg";